import { useRoutes } from 'react-router-dom';

// routes
import MainRoutes from './MainRoutes';
import AuthenticationRoutes, { ContactRoute, SeoRoutes, NotFoundRoute } from './AuthenticationRoutes';
import PlatformRoutes from './PlatformRoutes';
import UserRoutes from './UserRoutes';

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
    return useRoutes([MainRoutes, AuthenticationRoutes, ContactRoute, ...SeoRoutes, PlatformRoutes, ...UserRoutes, NotFoundRoute]);
}
